<!--NewYear Start-->
<ng-template class="theme-modal" #newyear let-modal>
    <div class="modal-content">
        <div class="modal-body modal7">
            <div class="container-fluid p-0">
    <div>
        <!-- <img src="assets/images/newyear.png" class="img-fluid1" width="770px" height="400px" alt=""(click)="modal.dismiss('Cross click')" (mouseleave)="modal.dismiss('Cross click')"> -->
        <!-- <img src="{{image_path}}" class="img-fluid" width="770px" height="400px" alt=""(click)="modal.dismiss('Cross click')" (mouseleave)="modal.dismiss('Cross click')"> -->
        <video class="img-fluid" width="770" height="400" controls autoplay (click)="modal.dismiss('Cross click')" (mouseleave)="modal.dismiss('Cross click')">
            <source src="{{video_path}}" type="video/mp4">
            Your browser does not support the video tag.
          </video>
          
    </div> 
    </div> 
    </div> 
    </div> 
    <!-- <div class="modal-content">
        <div class="modal-body modal7">
            <div class="container-fluid p-0">
                <div class="row">
                    <div class="col-12">
                        <div class="modal-bg">
                            <button type="button" class="close"  aria-label="Close" (click)="modal.dismiss('Cross click')">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div class="offer-content">
                            <img src="assets/images/news.jpeg" class="img-fluid" width="800px" height="400px" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</ng-template>
<!--modal popup end-->